import React from 'react'
import GenericTable from 'components/Table/GenericTable'
import { defaultProps } from 'components/Table/EmployerUserSignupsTable/component'

export const EmployerUserSignupsTable = ({ data }) => {
  return <GenericTable {...defaultProps} rows={data} />
}
